import { useMutation, useQueryClient, mutationOptions } from '@tanstack/react-query';

import { updateUserSettings } from '../../api/userSettingsService';

import { userSettingsKeys, userSettingsMutationKeys } from './keys';

export const saveUserSettingsOptions = (queryClient) =>
	mutationOptions({
		mutationKey: userSettingsMutationKeys.save,
		mutationFn: ({ updates }) => updateUserSettings({ updates }),
		onMutate: async ({ updates }) => {
			// Cancel any outgoing refetches
			await queryClient.cancelQueries({ queryKey: userSettingsKeys.list() });

			// Snapshot the previous value
			const previousSettings = queryClient.getQueryData(userSettingsKeys.list());

			// Optimistically update the settings
			queryClient.setQueryData(userSettingsKeys.list(), (old) => {
				if (!old) return old;
				return { ...old, ...updates };
			});

			return { previousSettings };
		},
		onError: (err, variables, context) => {
			// If the mutation fails, use the context returned from onMutate to roll back
			if (context?.previousSettings) {
				queryClient.setQueryData(userSettingsKeys.list(), context.previousSettings);
			}
		},
		onSuccess: () => {
			// Invalidate and refetch
			queryClient.invalidateQueries({ queryKey: userSettingsKeys.list() });
		},
		onSettled: () => {
			// Always refetch after error or success
			queryClient.invalidateQueries({ queryKey: userSettingsKeys.list() });
		},
	});

export function useSaveUserSettings() {
	const qc = useQueryClient();
	return useMutation(saveUserSettingsOptions(qc));
}
